import { render } from "./ViewOpeningBalanceModal.vue?vue&type=template&id=f911fb90"
import script from "./ViewOpeningBalanceModal.vue?vue&type=script&lang=js"
export * from "./ViewOpeningBalanceModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__